module.exports = __webpack_public_path__ + "static/media/logo.b818e175.png";